import React from "react";
import { useTranslation } from "react-i18next";
import { getPreviewImageSrc, PreviewKind } from "./verticalCatalog";

const CdnPreviewImage: React.FC<{
  kind: PreviewKind;
  className?: string;
}> = ({ kind, className = "" }) => {
  const { t, i18n } = useTranslation();
  const src = getPreviewImageSrc(kind, i18n.language);

  if (!src) return null;

  return (
    <div className={`w-full max-w-[340px] ${className}`}>
      <img
        loading="lazy"
        src={src}
        alt={t(`dashboard.verticalTunnel.preview.${kind}`) as string}
        className="w-full rounded-xl border border-gray-200 shadow-sm"
      />
    </div>
  );
};

export default CdnPreviewImage;
